import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ContentStates = {
  RECENTS: 'recents',
  LOADING: 'loading',
  RESULTS: 'results',
  UNSUPPORTED_QUERY: 'unsupported-query',
  EMPTY: 'empty',
  ERROR: 'error',
} as const

export type ContentStateEnum = Enum<typeof ContentStates>
